import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface DetailsData {
  sendings: {
    total: number;
    successful: number;
    scheduled: number;
  };
  properties: {
    total: number;
    available: number;
    rented: number;
  };
  owners: {
    total: number;
    active: number;
    inactive: number;
  };
  schedules: {
    total: number;
    pending: number;
    completed: number;
  };
}

interface DetailsTableProps {
  data: DetailsData;
}

export function DetailsTable({ data }: DetailsTableProps) {
  return (
    <Card className="hover:shadow-md transition-all duration-200">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-gray-700">
          Detalhes das Atividades
        </CardTitle>
      </CardHeader>
      <CardContent className="overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[120px]">Categoria</TableHead>
              <TableHead className="text-right">Total</TableHead>
              <TableHead className="text-right">Status</TableHead>
              <TableHead className="text-right">Detalhes</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell className="font-medium">Mensagens</TableCell>
              <TableCell className="text-right">{data.sendings.total}</TableCell>
              <TableCell className="text-right">
                <span className="text-green-600 font-medium">
                  {((data.sendings.successful / data.sendings.total) * 100).toFixed(1)}%
                </span>
              </TableCell>
              <TableCell className="text-right">{data.sendings.scheduled} agendadas</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">Imóveis</TableCell>
              <TableCell className="text-right">{data.properties.total}</TableCell>
              <TableCell className="text-right">
                <span className="text-blue-600 font-medium">
                  {data.properties.available}
                </span>
              </TableCell>
              <TableCell className="text-right">{data.properties.rented} alugados</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">Proprietários</TableCell>
              <TableCell className="text-right">{data.owners.total}</TableCell>
              <TableCell className="text-right">
                <span className="text-green-600 font-medium">
                  {((data.owners.active / data.owners.total) * 100).toFixed(1)}%
                </span>
              </TableCell>
              <TableCell className="text-right">{data.owners.inactive} inativos</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-medium">Agendamentos</TableCell>
              <TableCell className="text-right">{data.schedules.total}</TableCell>
              <TableCell className="text-right">
                <span className="text-yellow-600 font-medium">
                  {data.schedules.pending}
                </span>
              </TableCell>
              <TableCell className="text-right">{data.schedules.completed} concluídos</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}